<template>
  <div>

    <transition name="menu-popover">
      <div v-if="lightboxVideo" class="lightbox" @click="closeLightbox()">
        <h2 class="closeX" @click="closeLightbox()">
          <a>&#215;</a>
        </h2>
        <div class="lightbox-vid" v-html="lightboxVideo"></div>
      </div>
    </transition>

  <div style="font-size: 16px; padding-top: 20px;" class="px-4 sm:px-6 lg:px-8">
    <h2>Hello, {{ firstName }}!</h2>
    <p style="opacity: 80%;">
      I’m your Virtual Business Partner, here to provide clear insights and expert knowledge on Spacesaver’s product line. Ask me any questions about our products, and I’ll do my best to deliver the answers with the relevant documents to back them up!
    </p>
    <p style="margin-bottom: 10px;">
      <b>I pull information from these SpaceNET documents to generate my responses:</b>
    </p>
    
    <div
      class="grid-container"
      style="display: grid; gap: 10px; margin: 10px 0;"
    >
      <div
        v-for="(item, i) in docs"
        :key="i"
        style="display: flex; flex-direction: column;"
      >
        <div
          class="box"
          style="
            flex: 1;
            width: 100%;
            justify-content: center;
            text-align: left;
            background-color: #ffffff;
            padding: 15px;
            margin: 0;
            border-radius: 8px;
          "
        >
          <p style="margin: 0; font-size: 16px; color: #333;">
            <b>{{ item.title }}</b>
          </p>
          <p style="margin: 0; font-size: 15px; color: #333; opacity: 80%;">
            {{ item.body }}
          </p>
        </div>
      </div>
    </div>

   <p style="margin-top: 0; margin-bottom: 10px;"><strong>Tips for best results:</strong></p>

<ul>
  <li class="click-prompt">
    I work best when you ask questions about Spacesaver products, features, or use cases — rather than typing a specific document or file name.<br>
    Asking “What are the key safety features of a Mobile Storage System?” works much better than “mobile info sheet” or "tech data".
  </li>
  <li class="click-prompt">
    If the product information appears in a published PDF or spec sheet, I can usually find and summarize the content for you — just ask for the information, not the document name or type.
  </li>
  <li class="click-prompt">
    Part numbers, pricing, and product images are not currently searchable.
  </li>
</ul>

  <p style="margin-top: 0px; margin-bottom: 10px;"><b>Prompt examples:</b></p>
    <ul>
      <li class="click-prompt">Can you give me a quick overview of the key safety, usability, and security features of the Eclipse system?</li>
      <li class="click-prompt">Can you list all the configurations, sizes, and accessories offered for art racks?</li>
      <li class="click-prompt">What are some effective tips for selling Day Use Lockers to potential customers?</li>
      <li class="click-prompt">Can you tell me the load capacities for carriages in ActivRAC systems?</li>
      
      
    </ul>

    <p><b>Need A Tutorial? Watch the Overview Video <a style="color: #00b4b4; text-decoration: underline; cursor: pointer;" @click="showLightboxVideo(videoIframe)">HERE</a></b></p>
    <p style="margin-top: 10px; margin-bottom: 10px;"><b>Disclaimer</b></p>
    <p style="opacity: 80%;">
      This application strives to provide accurate answers based on retrieved data and advanced language models. However, the accuracy of responses depends on the underlying data sources. Answers may not always be error-free, and users should verify critical information independently from the referenced documents attached to the response. We are not liable for any decisions made based on the provided responses.
    </p>
  </div>
    </div>
</template>

<script>
export default {
  name: "ChatDisclaimer",
  props: {
  },
  data() {
    return {
      lightboxVideo: "",
      videoIframe: '<div style="position:relative;width:100%;height:0;padding-bottom:56.25%;"><iframe src="https://spacesaver.widen.net/view/video/oy2czbrawj/Sales--Marketing-Agent-Overview.mp4?u=b4bimj" webkitallowfullscreen mozallowfullscreen allowfullscreen title="Video for &quot;Sales & Marketing Agent Overview.mp4&quot;" frameborder="0" allowtransparency="true" scrolling="no" style="position:absolute;top:0;left:0;width:100%;height:100%;" ></iframe></div>',
      docs: [
        { title: "Marketing Materials", body: "Brochures, Info Sheets, Owner's Manuals, Planing Guides, Specs, Tech Data" },
        { title: "Service & Installation", body: "Installation Manuals, Owner's Manuals, Operating Instructions" },
        { title: "Sales & Training", body: "Sales, Sustainability, Contracts" },
      ],
    };
  },
  methods: {
    clickPrompt(prompt) {
      this.$emit('select-prompt', prompt);
    },
    showLightboxVideo(media) {
        this.lightboxVideo = media;
    },
    closeLightbox() {
      this.lightboxVideo = "";
  },
  },
  computed: {
    firstName() {
      return this.$store.state.user.FirstName;
    },
  },
  mounted() {

  },
};
</script>

<style scoped>
/* Mobile-first: Default to 1 column for screens 991px and below */
.grid-container {
  grid-template-columns: 1fr;
}

/* Desktop: Switch to 3 columns at 992px and above */
@media screen and (min-width: 992px) {
  .grid-container {
    grid-template-columns: repeat(3, 1fr);
  }
}
/*
.click-prompt {
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}
.click-prompt:hover {
  cursor: pointer;
  color: #000;
  text-decoration: none;
}
  */
</style>